module.exports = __webpack_public_path__ + "static/media/ser_iri_wat_fou_sew.f53f2355.png";